import { createFileRoute, Link } from "@tanstack/react-router";
import { useState, useMemo } from "react";
import { ChevronLeft } from "lucide-react";
import { PageHeader } from "@/components/app-shell";
import { CalcShell, Field, NumberInput, ResultCard, fmt } from "@/components/calculators/CalcShell";
import { AddToQuoteButton } from "@/components/calculators/AddToQuoteButton";
import { linesFromRekkverk } from "@/components/calculators/lineMappers";
import { rekkverkCalc } from "@/domain/calculators/carpenter";

export const Route = createFileRoute("/_authenticated/calculations/carpenter/rekkverk")({
  component: RekkverkPage,
});

function RekkverkPage() {
  const [lengde, setLengde] = useState<number | "">("");
  const [stolpeCc, setStolpeCc] = useState<number | "">(1.5);
  const [spileCc, setSpileCc] = useState<number | "">(100);
  const [hoyde, setHoyde] = useState<number | "">(1.0);

  const r = useMemo(() => {
    if (lengde === "") return null;
    return rekkverkCalc({
      lengde_m: Number(lengde),
      stolpe_cc_m: stolpeCc === "" ? undefined : Number(stolpeCc),
      spile_cc_mm: spileCc === "" ? undefined : Number(spileCc),
      hoyde_m: hoyde === "" ? undefined : Number(hoyde),
    });
  }, [lengde, stolpeCc, spileCc, hoyde]);

  return (
    <>
      <Link to="/calculations" className="mb-4 inline-flex items-center text-sm text-muted-foreground hover:text-foreground">
        <ChevronLeft className="h-4 w-4" /> Beregninger
      </Link>
      <PageHeader title="Rekkverk" subtitle="Beregn stolper, spiler og løpemeter håndløper." />
      <CalcShell
        title="Inndata"
        advisory="TEK17: rekkverk over 3 m fallhøyde krever ≥1,0 m og maks 100 mm mellom spiler."
        result={r ? (
          <>
            <ResultCard
            title="Materialbehov"
            rows={[
              { label: "Antall stolper", value: `${fmt(r.antall_stolper, 0)} stk`, strong: true },
              { label: "Antall spiler",  value: `${fmt(r.antall_spiler, 0)} stk` },
              { label: "Løpemeter håndløper", value: `${fmt(r.handloper_lm, 1)} m` },
              { label: "Løpemeter spile",     value: `${fmt(r.spile_lm, 1)} m` },
            ]}
          />
            <div className="mt-3 flex justify-end">
              <AddToQuoteButton sourceLabel={`Rekkverk`} lines={linesFromRekkverk(r)} defaultLaborHours={Math.max(0, Math.round((r.antall_stolper * 0.4) * 10) / 10)} />
            </div>
          </>
        ) : <div className="card p-5 text-sm text-muted-foreground">Fyll inn rekkverkslengde.</div>}
      >
        <Field label="Rekkverk­lengde" unit="m"><NumberInput value={lengde} onChange={setLengde} /></Field>
        <Field label="c/c stolper" unit="m"><NumberInput value={stolpeCc} onChange={setStolpeCc} /></Field>
        <Field label="c/c spiler" unit="mm"><NumberInput value={spileCc} onChange={setSpileCc} /></Field>
        <Field label="Rekkverk­høyde" unit="m"><NumberInput value={hoyde} onChange={setHoyde} /></Field>
      </CalcShell>
    </>
  );
}
